import { render, staticRenderFns } from "./CasualRecipients.vue?vue&type=template&id=b4ebf13e&scoped=true&"
import script from "./CasualRecipients.vue?vue&type=script&lang=js&"
export * from "./CasualRecipients.vue?vue&type=script&lang=js&"
import style0 from "./CasualRecipients.vue?vue&type=style&index=0&id=b4ebf13e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ebf13e",
  null
  
)

export default component.exports